// src/features/support/components/ManualAttachmentInput.tsx

import React, { useCallback } from "react";
import { useTicketDraftStore } from "../store/ticketDraftStore";

/**
 * ADR-110: lets the user attach a file/photo taken by an external means
 * (OS print screen, phone camera, etc.). Deliberately NOT masked — this
 * is the documented exception path for cases where the user needs the
 * censored content visible (e.g. reporting the exact password value that
 * isn't working). A short warning is shown to reduce accidental
 * disclosure; it is a UX nudge, not a technical control.
 */
export const ManualAttachmentInput: React.FC = () => {
  const addAttachment = useTicketDraftStore((s) => s.addAttachment);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (!file) return;
      addAttachment({
        id: crypto.randomUUID(),
        blob: file,
        filename: file.name,
        captureMethod: "manual_upload",
      });
      e.target.value = "";
    },
    [addAttachment]
  );

  return (
    <div
      style={{
        padding: "12px 16px",
        borderRadius: "10px",
        background: "rgba(245, 158, 11, 0.06)",
        border: "1px solid rgba(245, 158, 11, 0.3)",
        marginBottom: "1.25rem",
      }}
    >
      <p
        role="alert"
        data-testid="manual-upload-warning"
        style={{
          margin: "0 0 10px 0",
          fontSize: "0.82rem",
          fontWeight: 600,
          color: "#92400E",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          lineHeight: "1.5",
        }}
      >
        <span>⚠️</span>
        <span>
          این تصویر به‌صورت خودکار سانسور نمی‌شود؛ لطفاً پیش از ارسال، اطلاعات
          حساس را خودتان بررسی کنید.
        </span>
      </p>
      <input
        type="file"
        accept="image/*"
        onChange={handleChange}
        data-testid="manual-upload-input"
        style={{
          fontSize: "0.85rem",
          color: "#374151",
          cursor: "pointer",
        }}
      />
    </div>
  );
};

export default ManualAttachmentInput;
